import * as THREE from 'three';

const SILHOUETTE_MATERIAL = new THREE.MeshBasicMaterial({ color: '#000000' });

export default function SilhouetteFigure({ position = [0, 0, 0], scale = 0.55 }) {
  const [x, y, z] = position;

  return (
    <group position={[x, y, z]} scale={scale}>
      {/* Body — tall cylinder */}
      <mesh position={[0, 0.55, 0]} material={SILHOUETTE_MATERIAL}>
        <cylinderGeometry args={[0.15, 0.18, 1.1, 16]} />
      </mesh>

      {/* Head — sphere */}
      <mesh position={[0, 1.25, 0]} material={SILHOUETTE_MATERIAL}>
        <sphereGeometry args={[0.15, 16, 16]} />
      </mesh>

      {/* Legs — two thin cylinders */}
      <mesh position={[-0.07, -0.15, 0]} material={SILHOUETTE_MATERIAL}>
        <cylinderGeometry args={[0.06, 0.06, 0.5, 8]} />
      </mesh>
      <mesh position={[0.07, -0.15, 0]} material={SILHOUETTE_MATERIAL}>
        <cylinderGeometry args={[0.06, 0.06, 0.5, 8]} />
      </mesh>
    </group>
  );
}
